(() => {
  const dialog = document.querySelector('[data-newsletter-popup]');
  if (!(dialog instanceof HTMLDialogElement)) return;

  const STORAGE_KEY = 'pds-newsletter-popup';
  const SESSION_KEY = 'pds-newsletter-popup-seen';
  const DISMISSAL_DAYS = 7;
  const SUBSCRIPTION_DAYS = 365;

  const readState = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const writeState = (status, days) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ status, expiresAt: Date.now() + days * 24 * 60 * 60 * 1000 })
      );
    } catch (_error) {
      // Storage can be unavailable in private browsing; the form still works.
    }
  };

  const stateIsActive = () => {
    const state = readState();
    return Boolean(state?.expiresAt && state.expiresAt > Date.now());
  };

  const wasSeenThisVisit = () => {
    try {
      return sessionStorage.getItem(SESSION_KEY) === 'true';
    } catch (_error) {
      return false;
    }
  };

  const markAsSeenThisVisit = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, 'true');
    } catch (_error) {
      // Session storage can be unavailable; homepage-only rendering remains the fallback.
    }
  };

  const openDialog = () => {
    if (!dialog.open) {
      markAsSeenThisVisit();
      dialog.showModal();
    }
  };

  const submittedSuccessfully = dialog.dataset.success === 'true';
  const hasErrors = dialog.dataset.hasErrors === 'true';
  const inDesignMode = dialog.dataset.designMode === 'true';

  if (submittedSuccessfully) {
    writeState('subscribed', SUBSCRIPTION_DAYS);
    openDialog();
    dialog.querySelector('[data-newsletter-popup-success]')?.focus();
  } else if (hasErrors) {
    openDialog();
  } else if (!stateIsActive() && !wasSeenThisVisit()) {
    window.setTimeout(openDialog, inDesignMode ? 300 : 5500);
  }

  dialog.querySelectorAll('[data-newsletter-popup-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close('dismissed'));
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close('dismissed');
  });

  dialog.addEventListener('close', () => {
    if (!submittedSuccessfully && dialog.returnValue === 'dismissed') {
      writeState('dismissed', DISMISSAL_DAYS);
    }
  });
})();
